import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaCalendarAlt, FaEye, FaArrowLeft, FaFileInvoiceDollar } from "react-icons/fa";
import styles from "../FeeType/styles.module.css";
import {
    CustomButton,
    CustomDropdown,
    CustomTextInput,
} from "../../../../components";
import {
    fetchClassOptions,
    fetchSectionOptions,
    clearSectionOptions,
} from "../../../../redux/Masterdata";
import AxiosInstance, { TokenService } from "../../../../services/Api";
import PopupModal from "../../../../components/PopupModal/PopupModal";
import { useDispatch, useSelector } from "react-redux";
import CustomMRTTable from "../../../../components/CustomMRTTable/CustomMRTTable";

/* ── Sample fee data ── */
const SAMPLE_FEE_DETAILS = [
    { id: 1, fee_type_name: "Tuition Fee", amount: 10000 },
    { id: 2, fee_type_name: "Examination Fee", amount: 5000 },
    { id: 3, fee_type_name: "Laboratory Fee", amount: 2500 },
    { id: 4, fee_type_name: "Library Fee", amount: 8000 },
    { id: 5, fee_type_name: "Development Fee", amount: 1200 },
    { id: 6, fee_type_name: "Activity Fee", amount: 4000 },
    { id: 7, fee_type_name: "Maintenance Fee", amount: 2000 },
    { id: 8, fee_type_name: "Health Insurance Fee", amount: 6500 },
    { id: 9, fee_type_name: "Placement Fee", amount: 3500 },
    { id: 10, fee_type_name: "Field Trip Fee", amount: 7000 },
    { id: 11, fee_type_name: "Graduation Fee", amount: 1200 },
];



/* ── Inline styles ── */
const inlineStyles = {
    feeTable: {
        width: "100%",
        borderCollapse: "separate",
        borderSpacing: "0 4px",
    },
    feeTableHead: {
        fontSize: 13,
        fontWeight: 700,
        color: "#1e3a5f",
        padding: "10px 16px",
        textAlign: "left",
        borderBottom: "2px solid #e5e7eb",
    },
    feeTableHeadRight: {
        fontSize: 13,
        fontWeight: 700,
        color: "#1e3a5f",
        padding: "10px 16px",
        textAlign: "right",
        borderBottom: "2px solid #e5e7eb",
    },
    feeRowEven: {
        backgroundColor: "#f3f4f6",
    },
    feeRowOdd: {
        backgroundColor: "#ffffff",
    },
    feeCellLeft: {
        padding: "12px 16px",
        fontSize: 14,
        color: "#1e3a5f",
        fontWeight: 500,
    },
    feeCellRight: {
        padding: "12px 16px",
        fontSize: 14,
        color: "#1e3a5f",
        fontWeight: 600,
        textAlign: "right",
    },
    totalRow: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: 16,
        padding: "16px 16px 0",
        marginTop: 8,
    },
    totalLabel: {
        fontSize: 16,
        fontWeight: 700,
        color: "#1e3a5f",
    },
    totalValue: {
        fontSize: 18,
        fontWeight: 700,
        color: "#f97316",
    },
    challanBtn: {
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        padding: "6px 14px",
        fontSize: 13,
        fontWeight: 600,
        color: "#1e3a5f",
        background: "#f0f4ff",
        border: "1px solid #c7d2fe",
        borderRadius: 6,
        cursor: "pointer",
        transition: "all 0.2s",
    },
    subHeading: {
        fontSize: 16,
        fontWeight: 700,
        color: "#1e3a5f",
        marginBottom: 12,
    },
};/* ── Inline styles ── */
const S = {
    card: {
        background: "#fff",
        borderRadius: 10,
        border: "1px solid #e5e7eb",
        padding: "20px 24px",
        marginBottom: 20,
    },
    infoGrid: {
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)",
        gap: 20,
    },
    infoLabel: {
        fontSize: 12,
        color: "#6b7280",
        marginBottom: 4,
        fontWeight: 500,
    },
    infoValue: {
        fontSize: 15,
        color: "#1e3a5f",
        fontWeight: 600,
        paddingBottom: 8,
        borderBottom: "1px solid #e5e7eb",
    },
    feeTable: {
        width: "100%",
        borderCollapse: "separate",
        borderSpacing: "0 2px",
    },
    th: {
        fontSize: 13,
        fontWeight: 700,
        color: "#1e3a5f",
        padding: "10px 16px",
        textAlign: "left",
        borderBottom: "2px solid #e5e7eb",
    },
    thRight: {
        fontSize: 13,
        fontWeight: 700,
        color: "#1e3a5f",
        padding: "10px 16px",
        textAlign: "right",
        borderBottom: "2px solid #e5e7eb",
    },
    rowEven: { backgroundColor: "#f3f4f6" },
    rowOdd: { backgroundColor: "#ffffff" },
    cellLeft: {
        padding: "12px 16px",
        fontSize: 14,
        color: "#1e3a5f",
        fontWeight: 500,
    },
    cellRight: {
        padding: "12px 16px",
        fontSize: 14,
        color: "#1e3a5f",
        fontWeight: 600,
        textAlign: "right",
    },
    totalRow: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: 16,
        padding: "16px 16px 0",
    },
    totalLabel: {
        fontSize: 15,
        fontWeight: 700,
        color: "#1e3a5f",
    },
    totalValue: {
        fontSize: 17,
        fontWeight: 700,
        color: "#f97316",
    },
    // Payment summary
    summaryTable: {
        width: "100%",
        borderCollapse: "collapse",
    },
    summaryRow: {
        borderBottom: "1px solid #f3f4f6",
    },
    summaryRowBold: {
        borderTop: "2px solid #e5e7eb",
        borderBottom: "1px solid #f3f4f6",
    },
    summaryLabel: {
        padding: "10px 16px",
        fontSize: 14,
        color: "#1e3a5f",
        fontWeight: 500,
    },
    summaryLabelBold: {
        padding: "10px 16px",
        fontSize: 14,
        color: "#1e3a5f",
        fontWeight: 700,
    },
    summaryValue: {
        padding: "10px 16px",
        fontSize: 14,
        color: "#1e3a5f",
        fontWeight: 600,
        textAlign: "right",
    },
    summaryValueOrange: {
        padding: "10px 16px",
        fontSize: 14,
        color: "#f97316",
        fontWeight: 600,
        textAlign: "right",
    },
    summaryValueRed: {
        padding: "10px 16px",
        fontSize: 14,
        color: "#dc2626",
        fontWeight: 600,
        textAlign: "right",
    },
    grandTotalLabel: {
        padding: "14px 16px",
        fontSize: 15,
        color: "#1e3a5f",
        fontWeight: 700,
    },
    grandTotalValue: {
        padding: "14px 16px",
        fontSize: 22,
        color: "#f97316",
        fontWeight: 700,
        textAlign: "right",
    },
    // Ledger
    ledgerTh: {
        fontSize: 13,
        fontWeight: 700,
        color: "#1e3a5f",
        padding: "10px 16px",
        textAlign: "left",
        borderBottom: "2px solid #e5e7eb",
    },
    ledgerCell: {
        padding: "12px 16px",
        fontSize: 14,
        color: "#1e3a5f",
        fontWeight: 500,
    },
    // Buttons
    btnRow: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: 16,
        marginTop: 24,
        marginBottom: 24,
    },
    cancelBtn: {
        padding: "10px 28px",
        fontSize: 14,
        fontWeight: 600,
        color: "#fff",
        background: "#1e3a5f",
        border: "none",
        borderRadius: 6,
        cursor: "pointer",
    },
    saveBtn: {
        padding: "10px 28px",
        fontSize: 14,
        fontWeight: 600,
        color: "#fff",
        background: "#f97316",
        border: "none",
        borderRadius: 6,
        cursor: "pointer",
    },
    challanBtn: {
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        padding: "6px 14px",
        fontSize: 13,
        fontWeight: 600,
        color: "#1e3a5f",
        background: "#f0f4ff",
        border: "1px solid #c7d2fe",
        borderRadius: 6,
        cursor: "pointer",
    },
};


const ViewFeeAssign = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const { translations } = useSelector((state) => state.language);

    const user = TokenService.getUser();
    const clientData = user?.client_data?.[0] || {};
    const school_id = clientData?.school_id || "";
    const master_id = clientData?.master_id || "";
    const academic_year_id =
        clientData?.academic_year_id || clientData?.academic_id || "";
    const academic_year = clientData?.academic_year || "";
    const user_id = user?.id || "";
    const roleId = Number(user?.role?.id);

    const {
        classOptions: reduxClassOptions,
        staffClassAndSubjectOptions,
        sectionOptions: reduxSectionOptions,
    } = useSelector((state) => state.masterData);

    // ── View mode: "list" | "challan" ──
    const [viewMode, setViewMode] = useState("list");
    const [selectedStudent, setSelectedStudent] = useState(null);
    const [feeDetails, setFeeDetails] = useState([]);
    const [feeLoading, setFeeLoading] = useState(false);
    const [payingAmount, setPayingAmount] = useState("");
    const [paymentSummary, setPaymentSummary] = useState(null);

    // ── Student list state ──
    const [data, setData] = useState([]);
    const [selectedClass, setSelectedClass] = useState("");
    const [selectedSection, setSelectedSection] = useState("");
    const [tableLoading, setTableLoading] = useState(false);
    const [searchInput, setSearchInput] = useState("");
    const [rowCount, setRowCount] = useState(0);
    const [apiSearch, setApiSearch] = useState("");
    const [formData, setFormData] = useState({ medium: "", groupType: "" });
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 10,
    });

    // ── Group type (editable on challan view) ──
    const [feeTypeOptions, setFeeTypeOptions] = useState([]);
    const [feeTypeLoading, setFeeTypeLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [errors, setErrors] = useState({});
    const [ledgerData, setLedgerData] = useState([]);

    const [modalState, setModalState] = useState({
        open: false,
        type: "success",
        message: "",
        redirectPath: "",
    });
    const SAMPLE_LEDGER = [
        { id: 1, date: "05/05/2026", payment_mode: "Cash Payment", paid: 0, balance: 52400 },
        { id: 2, date: "05/05/2026", payment_mode: "Cash Payment", paid: 27400, balance: 25000 },
        { id: 3, date: "05/05/2026", payment_mode: "Cash Payment", paid: 25000, balance: 0 },
    ];

    const SAMPLE_PAYMENT_SUMMARY = {
        due_date: "10/06/2026",
        common_fees: 50900,
        optional_fees: 2000,
        discount_applied: 500,
        net_payable: 52400,
        fine: 0,
        total_paid: 26400,
        total_amount_to_be_paid: 25000,
    };
    // ── Fetch class options ──
    useEffect(() => {
        dispatch(
            fetchClassOptions({
                id: parseInt(school_id),
                academic_year: academic_year,
            }),
        );
    }, [dispatch, school_id]);

    // ── Fetch fee type options ──
    useEffect(() => {
        fetchFeeTypes();
    }, [school_id, academic_year_id]);

    const fetchFeeTypes = async () => {
        if (!school_id || !academic_year_id) return;
        setFeeTypeLoading(true);
        try {
            const response = await AxiosInstance.post(
                "schoolFees/list/fees_type",
                {
                    school_id: Number(school_id),
                    academic_id: Number(academic_year_id),
                    page: 1,
                    limit: 100,
                    search: "",
                },
            );
            if (response?.data?.status && Array.isArray(response.data.data)) {
                setFeeTypeOptions(
                    response.data.data.map((item) => ({
                        value: String(item.id),
                        label: item.name,
                    })),
                );
            } else {
                setFeeTypeOptions([]);
            }
        } catch (error) {
            console.error("Error fetching fee types:", error);
            setFeeTypeOptions([]);
        } finally {
            setFeeTypeLoading(false);
        }
    };

    // ── Fetch student list ──
    const fetchStudentList = useCallback(async () => {

        setTableLoading(true);
        try {
            const response = await AxiosInstance.post("school/studentsList", {
                school_id: Number(school_id),
                student_class: String(selectedClass),
                section: String(selectedSection),
                gender: "",
                search: apiSearch,
                page: pagination.pageIndex + 1,
                limit: pagination.pageSize,
                academic_year_id: Number(academic_year_id),
            });
            if (response?.data?.status && Array.isArray(response.data.data)) {
                setData(response.data.data);
                setRowCount(response.data.pagination?.total || 0);
            } else {
                setData([]);
                setRowCount(0);
            }
        } catch (error) {
            console.error("Error fetching student list:", error);

        } finally {
            setTableLoading(false);
        }
    }, [
        school_id,
        selectedClass,
        selectedSection,
        apiSearch,
        pagination.pageIndex,
        pagination.pageSize,
        academic_year_id,
    ]);

    useEffect(() => {
        fetchStudentList();
    }, [fetchStudentList]);

    // ── Fetch fee challan for a student ──
    const fetchFeeChallan = useCallback(
        async (student) => {
            if (!student?.stud_id || !school_id) {
                setFeeDetails(SAMPLE_FEE_DETAILS);
                setPaymentSummary(SAMPLE_PAYMENT_SUMMARY);
                setLedgerData(SAMPLE_LEDGER);
                return;
            }
            setFeeLoading(true);
            setFeeDetails([]);
            setLedgerData([]);
            setPaymentSummary(null);
            try {
                const response = await AxiosInstance.post(
                    "schoolFees/studentFeeDetails",
                    {
                        school_id: Number(school_id),
                        student_id: student.stud_id,
                        academic_year_id: Number(academic_year_id),
                    },
                );
                if (
                    response?.data?.status &&
                    response?.data?.data
                ) {
                    const d = response.data.data;
                    setFeeDetails(
                        Array.isArray(d.fees) && d.fees.length > 0
                            ? d.fees
                            : SAMPLE_FEE_DETAILS,
                    );
                    setPaymentSummary(d.payment_summary || SAMPLE_PAYMENT_SUMMARY);
                    setLedgerData(
                        Array.isArray(d.ledger) && d.ledger.length > 0
                            ? d.ledger
                            : SAMPLE_LEDGER,
                    );
                } else {
                    setFeeDetails(SAMPLE_FEE_DETAILS);
                    setPaymentSummary(SAMPLE_PAYMENT_SUMMARY);
                    setLedgerData(SAMPLE_LEDGER);
                }
            } catch (error) {
                setFeeDetails(SAMPLE_FEE_DETAILS);
                setPaymentSummary(SAMPLE_PAYMENT_SUMMARY);
                setLedgerData(SAMPLE_LEDGER);
            } finally {
                setFeeLoading(false);
            }
        },
        [school_id, academic_year_id],
    );

    // ── Dropdown options ──
    const mediumOptions = [
        { label: "Tamil", value: "tamil" },
        { label: "English", value: "english" },
        { label: "Hindi", value: "hindi" },
    ];

    const sectionOptions = useMemo(
        () => [
            {
                value: "",
                label:
                    translations.labels?.selectSection || "Select Section",
            },
            ...reduxSectionOptions,
        ],
        [reduxSectionOptions, translations],
    );

    const classOptions = useMemo(() => {
        const sourceData =
            roleId === 3 ? staffClassAndSubjectOptions : reduxClassOptions;
        return [
            {
                value: "",
                label:
                    translations.labels?.selectClass || "Select Class",
            },
            ...sourceData.map((item) => ({
                value: item.class_id ?? item.value,
                label: item.class_name ?? item.label,
            })),
        ];
    }, [reduxClassOptions, staffClassAndSubjectOptions, roleId, translations]);

    // ── Handlers ──
    const handleClassChange = useCallback(
        (value) => {
            const classId =
                typeof value === "object" ? value?.value : value;
            setSelectedClass(classId);
            setSelectedSection("");
            dispatch(clearSectionOptions());
            if (classId) {
                dispatch(
                    fetchSectionOptions({
                        id: [parseInt(classId)],
                        school_id: parseInt(school_id),
                        staff_id: parseInt(master_id),
                        subject_staff: 1,
                    }),
                );
            }
            setPagination((prev) => ({ ...prev, pageIndex: 0 }));
        },
        [dispatch, school_id],
    );

    const handleSectionChange = useCallback((value) => {
        const sectionId =
            typeof value === "object" ? value?.value : value;
        setSelectedSection(sectionId);
        setPagination((prev) => ({ ...prev, pageIndex: 0 }));
    }, []);

    const handleMediumChange = useCallback((value) => {
        const val =
            value && typeof value === "object"
                ? value.value ?? ""
                : value ?? "";
        setFormData((prev) => ({ ...prev, medium: val }));
    }, []);

    const handleSearchEnter = useCallback((value) => {
        setApiSearch(value || "");
        setPagination((prev) => ({ ...prev, pageIndex: 0 }));
    }, []);

    const handleViewChallan = useCallback(
        (student) => {
            setSelectedStudent(student);
            setFormData((prev) => ({ ...prev, groupType: "" }));
            setPayingAmount("");
            setErrors({});
            setViewMode("challan");
            fetchFeeChallan(student);
        },
        [fetchFeeChallan],
    );

    const handleBackToList = useCallback(() => {
        setViewMode("list");
        setSelectedStudent(null);
        setFeeDetails([]);
        setLedgerData([]);
        setPaymentSummary(null);
        setPayingAmount("");
        setFormData((prev) => ({ ...prev, groupType: "" }));
        setErrors({});
    }, []);
    const handleSaveAndPrint = async () => {
        if (!payingAmount || Number(payingAmount) <= 0) {
            setErrors({ payingAmount: "Please enter a valid amount" });
            return;
        }
        setSubmitting(true);
        try {
            const payload = {
                school_id: Number(school_id),
                academic_year_id: Number(academic_year_id),
                student_id: selectedStudent?.stud_id,
                amount: Number(payingAmount),
                payment_mode: "Cash Payment",
                created_by: user_id,
            };
            const response = await AxiosInstance.post(
                "schoolFees/collectPayment",
                payload,
            );
            if (response?.data?.status) {
                setModalState({
                    open: true,
                    type: "success",
                    message:
                        response?.data?.message ||
                        "Payment saved successfully!",
                    redirectPath: "",
                });
                fetchFeeChallan(selectedStudent);
                setPayingAmount("");
            } else {
                setModalState({
                    open: true,
                    type: "error",
                    message:
                        response?.data?.message || "Something went wrong!",
                    redirectPath: "",
                });
            }
        } catch (error) {
            setModalState({
                open: true,
                type: "error",
                message: "Failed to save payment. Please try again.",
                redirectPath: "",
            });
        } finally {
            setSubmitting(false);
        }
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        if (errors[name]) {
            setErrors((prev) => ({ ...prev, [name]: "" }));
        }
    };

    const handleDropdownChange = (name, value) => {
        const finalValue =
            value && typeof value === "object"
                ? value.value ?? value.target?.value ?? ""
                : value;
        setFormData((prev) => ({ ...prev, [name]: finalValue }));
        if (errors[name]) {
            setErrors((prev) => ({ ...prev, [name]: "" }));
        }
    };

    const handleSubmitGroup = async () => {
        if (!formData.groupType) {
            setErrors({ groupType: "Group type is required" });
            return;
        }
        setSubmitting(true);
        try {
            const payload = {
                school_id: Number(school_id),
                academic_year_id: Number(academic_year_id),
                student_id: selectedStudent?.stud_id,
                fee_type: Number(formData.groupType),
                created_by: user_id,
            };
            const response = await AxiosInstance.post(
                "schoolFees/assignFeeGroup",
                payload,
            );
            if (response?.data?.status) {
                setModalState({
                    open: true,
                    type: "success",
                    message:
                        response?.data?.message ||
                        "Group assigned successfully!",
                    redirectPath: "",
                });
                fetchStudentList();
            } else {
                setModalState({
                    open: true,
                    type: "error",
                    message:
                        response?.data?.message || "Something went wrong!",
                    redirectPath: "",
                });
            }
        } catch (error) {
            console.error("Error assigning group:", error);
            setModalState({
                open: true,
                type: "error",
                message: "Failed to assign group. Please try again.",
                redirectPath: "",
            });
        } finally {
            setSubmitting(false);
        }
    };

    const handleModalOk = () => {
        setModalState((prev) => ({ ...prev, open: false }));
    };

    // ── Total amount ──
    const totalAmount = useMemo(
        () =>
            feeDetails.reduce(
                (sum, item) => sum + (Number(item.amount) || 0),
                0,
            ),
        [feeDetails],
    );

    // ── Format currency ──
    const formatCurrency = (val) =>
        new Intl.NumberFormat("en-IN", {
            style: "currency",
            currency: "INR",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(val);
    const summary = paymentSummary || SAMPLE_PAYMENT_SUMMARY;

    // ── Student list columns ──
    const columns = useMemo(
        () => [
            {
                accessorKey: "student_id",
                header:
                    translations.labels?.admissionId || "Admission ID",
                enableSorting: true,
                enableColumnFilter: false,
            },
            {
                accessorKey: "name",
                header:
                    translations.labels?.studentName || "Student Name",
                enableSorting: true,
                enableColumnFilter: false,
            },
            {
                accessorKey: "group_name",
                header: translations.labels?.group || "Group",
                enableSorting: true,
                enableColumnFilter: false,
                Cell: ({ cell }) => cell.getValue() || "-",
            },
            {
                accessorKey: "fee_status",
                header: translations.labels?.status || "Status",
                enableSorting: true,
                enableColumnFilter: false,
                Cell: ({ cell }) => cell.getValue() || "-",
            },
            {
                id: "actions",
                header: translations.labels?.view || "View",
                enableSorting: false,
                enableColumnFilter: false,
                size: 100,
                Cell: ({ row }) => (
                    <button
                        style={inlineStyles.challanBtn}
                        onClick={() => handleViewChallan(row.original)}
                        title="View Challan"
                    >
                        <FaFileInvoiceDollar size={14} />
                        Challan
                    </button>
                ),
            },
        ],
        [translations, handleViewChallan],
    );

    // ════════════════════════════════════════════
    //  RENDER — Challan View
    // ════════════════════════════════════════════
    if (viewMode === "challan" && selectedStudent) {
        return (
            <>
                <PopupModal
                    open={modalState.open}
                    title={
                        modalState.type === "success"
                            ? translations.labels?.success || "Success"
                            : translations.labels?.failed || "Failed"
                    }
                    message={modalState.message}
                    onOk={handleModalOk}
                />

                <div className={styles.container}>
                    {/* ── Student Details Header ── */}
                    <div className={styles.header}>
                        <div className={styles.headerIcon}>
                            <FaCalendarAlt />
                        </div>
                        <h1 className={styles.headerTitle}>
                            {translations.labels?.studentDetails ||
                                "Student Details"}
                        </h1>
                    </div>

                    <div className="row">
                        <div className="col-lg-3 px-2 col-md-6 col-sm-12">
                            <CustomTextInput
                                label={translations.labels?.admissionId || "Admission ID"}
                                name="admissionId"
                                type="text"
                                value={selectedStudent.student_id || ""}
                                onChange={handleInputChange}
                                disabled
                            />
                        </div>
                        <div className="col-lg-3 px-2 col-md-6 col-sm-12">
                            <CustomTextInput
                                label={translations.labels?.studentName || "Student Name"}
                                name="studentName"
                                type="text"
                                value={selectedStudent.name || ""}
                                onChange={handleInputChange}
                                disabled
                            />
                        </div>
                        <div className="col-lg-3 px-2 col-md-6 col-sm-12">
                            <CustomTextInput
                                label={translations.labels?.class || "Class"}
                                name="className"
                                type="text"
                                value={selectedStudent.class || ""}
                                onChange={handleInputChange}
                                disabled
                            />
                        </div>
                        <div className="col-lg-3 px-2 col-md-6 col-sm-12">
                            <CustomTextInput
                                label={translations.labels?.section || "Section"}
                                name="className"
                                type="text"
                                value={selectedStudent.section || ""}
                                onChange={handleInputChange}
                                disabled
                            />
                        </div>
                        <div className="col-lg-3 px-2 col-md-6 col-sm-12">
                            <CustomDropdown
                                label={
                                    translations.labels?.groupType ||
                                    "Group Type"
                                }
                                name="groupType"
                                value={formData.groupType}
                                onChange={(value) =>
                                    handleDropdownChange("groupType", value)
                                }
                                options={feeTypeOptions}
                                placeholder={
                                    feeTypeLoading
                                        ? translations.labels?.loading ||
                                        "Loading..."
                                        : translations.labels
                                            ?.selectFeeType ||
                                        "Select fee type"
                                }
                                required
                                error={errors.groupType}
                                isDisabled={feeTypeLoading}
                            />
                        </div>
                    </div>

                    {/* ── Fees Details Header ── */}
                    <div className={styles.header} style={{ marginTop: 24 }}>
                        <div className={styles.headerIcon}>
                            <FaCalendarAlt />
                        </div>
                        <h1 className={styles.headerTitle}>
                            {translations.labels?.feesDetails ||
                                "Fees Details"}
                        </h1>
                    </div>

                    <h3 style={inlineStyles.subHeading}>
                        {translations.labels?.commonFees || "Common Fees"}
                    </h3>

                    {feeLoading ? (
                        <div
                            style={{
                                textAlign: "center",
                                padding: 40,
                                color: "#6b7280",
                            }}
                        >
                            {translations.labels?.loading || "Loading..."}
                        </div>
                    ) : feeDetails.length === 0 ? (
                        <div
                            style={{
                                textAlign: "center",
                                padding: 40,
                                color: "#6b7280",
                            }}
                        >
                            {translations.labels?.noDataAvailable ||
                                "No fee details available"}
                        </div>
                    ) : (
                        <>
                            <table style={inlineStyles.feeTable}>
                                <thead>
                                    <tr>
                                        <th style={inlineStyles.feeTableHead}>
                                            {translations.labels?.feeType ||
                                                "Fee Type"}{" "}
                                            ↕
                                        </th>
                                        <th
                                            style={
                                                inlineStyles.feeTableHeadRight
                                            }
                                        >
                                            {translations.labels?.amountRupee ||
                                                "Amount (₹)"}{" "}
                                            ↕
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {feeDetails.map((fee, index) => (
                                        <tr
                                            key={fee.id || index}
                                            style={
                                                index % 2 === 0
                                                    ? inlineStyles.feeRowEven
                                                    : inlineStyles.feeRowOdd
                                            }
                                        >
                                            <td
                                                style={
                                                    inlineStyles.feeCellLeft
                                                }
                                            >
                                                {fee.fee_type_name ||
                                                    fee.name ||
                                                    "-"}
                                            </td>
                                            <td
                                                style={
                                                    inlineStyles.feeCellRight
                                                }
                                            >
                                                {formatCurrency(
                                                    fee.amount || 0,
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            <div style={inlineStyles.totalRow}>
                                <span style={inlineStyles.totalLabel}>
                                    {translations.labels?.totalAmount ||
                                        "Total Amount"}
                                </span>
                                <span style={inlineStyles.totalValue}>
                                    {formatCurrency(totalAmount)}
                                </span>
                            </div>
                        </>
                    )}
                    <div className={styles.header} style={{ marginTop: 24 }}>
                        <div className={styles.headerIcon}>
                            <FaCalendarAlt />
                        </div>
                        <h1 className={styles.headerTitle}>
                            {translations.labels?.paymentSummary ||
                                "Payment Summary"}
                        </h1>
                    </div>

                    <table style={styles.summaryTable}>
                        <tbody>
                            <tr style={S.summaryRow}>
                                <td style={S.summaryLabelBold}>Due Date</td>
                                <td style={S.summaryValueOrange}>
                                    {summary.due_date || "-"}
                                </td>
                            </tr>
                            <tr style={S.summaryRow}>
                                <td style={S.summaryLabel}>Common Fees</td>
                                <td style={S.summaryValue}>
                                    {formatCurrency(summary.common_fees || 0)}
                                </td>
                            </tr>
                            <tr style={S.summaryRow}>
                                <td style={S.summaryLabel}>Optional Fees</td>
                                <td style={S.summaryValue}>
                                    {formatCurrency(summary.optional_fees || 0)}
                                </td>
                            </tr>
                            <tr style={S.summaryRow}>
                                <td style={S.summaryLabel}>Discount Applied</td>
                                <td style={S.summaryValue}>
                                    - {formatCurrency(summary.discount_applied || 0)}
                                </td>
                            </tr>
                            <tr style={S.summaryRowBold}>
                                <td style={S.summaryLabelBold}>Net Payable</td>
                                <td style={S.summaryValue}>
                                    {formatCurrency(summary.net_payable || 0)}
                                </td>
                            </tr>
                            <tr style={S.summaryRow}>
                                <td style={S.summaryLabel}>Fine</td>
                                <td style={S.summaryValue}>
                                    {formatCurrency(summary.fine || 0)}
                                </td>
                            </tr>
                            <tr style={S.summaryRow}>
                                <td style={S.summaryLabel}>Total Paid</td>
                                <td style={S.summaryValue}>
                                    - {formatCurrency(summary.total_paid || 0)}
                                </td>
                            </tr>
                            <tr
                                style={{
                                    borderTop: "2px solid #1e3a5f",
                                }}
                            >
                                <td style={S.grandTotalLabel}>
                                    Total Amount to be Paid
                                </td>
                                <td style={S.grandTotalValue}>
                                    {formatCurrency(
                                        summary.total_amount_to_be_paid || 0,
                                    )}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div className={styles.header} style={{ marginTop: 24 }}>
                        <div className={styles.headerIcon}>
                            <FaCalendarAlt />
                        </div>
                        <h1 className={styles.headerTitle}>
                            {translations.labels?.paymentAmount ||
                                "Payment Amount"}
                        </h1>
                    </div>
                    <div style={{ maxWidth: 250 }}>
                        <label
                            style={{
                                fontSize: 14,
                                fontWeight: 600,
                                color: "#1e3a5f",
                                display: "block",
                                marginBottom: 6,
                            }}
                        >
                            Amount paying now
                        </label>
                        <input
                            type="number"
                            value={payingAmount}
                            onChange={(e) => {
                                setPayingAmount(e.target.value);
                                if (errors.payingAmount) {
                                    setErrors((prev) => ({
                                        ...prev,
                                        payingAmount: "",
                                    }));
                                }
                            }}
                            placeholder={formatCurrency(
                                summary.total_amount_to_be_paid || 0,
                            )}
                            style={{
                                width: "100%",
                                padding: "10px 14px",
                                fontSize: 14,
                                border: errors.payingAmount
                                    ? "1px solid #dc2626"
                                    : "1px solid #d1d5db",
                                borderRadius: 6,
                                outline: "none",
                                color: "#1e3a5f",
                                fontWeight: 600,
                            }}
                        />
                        {errors.payingAmount && (
                            <span
                                style={{
                                    fontSize: 12,
                                    color: "#dc2626",
                                    marginTop: 4,
                                    display: "block",
                                }}
                            >
                                {errors.payingAmount}
                            </span>
                        )}
                    </div>




                    {/* ── Buttons ── */}
                    <div
                        className={styles.buttonContainer}
                        style={{ marginTop: 24 }}
                    >
                        <CustomButton
                            type="button"
                            variant="contained"
                            className={styles.cancelButton}
                            fullWidth={false}
                            onClick={handleBackToList}
                        >
                            {translations.labels?.back || "Back"}
                        </CustomButton>

                        <CustomButton
                            type="button"
                            variant="contained"
                            className={styles.submitButton}
                            fullWidth={false}
                            loading={submitting}
                            loadingText={
                                translations.labels?.submitting ||
                                "Submitting..."
                            }
                            onClick={handleSubmitGroup}
                        >
                            {translations.labels?.submit || "Submit"}
                        </CustomButton>
                    </div>
                    <div className={styles.header} style={{ marginTop: 24 }}>
                        <div className={styles.headerIcon}>
                            <FaCalendarAlt />
                        </div>
                        <h1 className={styles.headerTitle}>
                            {translations.labels?.feeLedger ||
                                "Fee Ledger"}
                        </h1>
                    </div>
                    <table style={S.feeTable}>
                        <thead>
                            <tr>
                                <th style={S.ledgerTh}>Date</th>
                                <th style={S.ledgerTh}>Payment Mode</th>
                                <th style={S.ledgerTh}>Paid</th>
                                <th style={S.ledgerTh}>Balance</th>
                            </tr>
                        </thead>
                        <tbody>
                            {ledgerData.length === 0 ? (
                                <tr>
                                    <td
                                        colSpan={4}
                                        style={{
                                            textAlign: "center",
                                            padding: 30,
                                            color: "#6b7280",
                                        }}
                                    >
                                        No ledger entries
                                    </td>
                                </tr>
                            ) : (
                                ledgerData.map((entry, i) => (
                                    <tr
                                        key={entry.id || i}
                                        style={
                                            i % 2 === 0
                                                ? S.rowEven
                                                : S.rowOdd
                                        }
                                    >
                                        <td style={S.ledgerCell}>
                                            {entry.date || "-"}
                                        </td>
                                        <td style={S.ledgerCell}>
                                            {entry.payment_mode || "-"}
                                        </td>
                                        <td style={S.ledgerCell}>
                                            {entry.paid === 0
                                                ? "0"
                                                : formatCurrency(
                                                    entry.paid || 0,
                                                )}
                                        </td>
                                        <td style={S.ledgerCell}>
                                            {entry.balance === 0
                                                ? "0"
                                                : formatCurrency(
                                                    entry.balance || 0,
                                                )}
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </>
        );
    }

    // ════════════════════════════════════════════
    //  RENDER — Student List View
    // ════════════════════════════════════════════
    return (
        <>
            <PopupModal
                open={modalState.open}
                title={
                    modalState.type === "success"
                        ? translations.labels?.success || "Success"
                        : translations.labels?.failed || "Failed"
                }
                message={modalState.message}
                onOk={handleModalOk}
            />

            <div className={styles.container}>
                <div className={styles.header}>
                    <div className={styles.headerIcon}>
                        <FaCalendarAlt />
                    </div>
                    <h1 className={styles.headerTitle}>
                        {translations.labels?.viewFeeAssign ||
                            "View Fee Assign"}
                    </h1>
                </div>

                {/* ── Filters ── */}
                <div className="row" style={{ marginBottom: 16 }}>
                    <div className="col-lg-3 px-2 col-md-6 col-sm-12">
                        <CustomDropdown
                            label={translations.labels?.class || "Class"}
                            name="filterClass"
                            value={selectedClass}
                            onChange={handleClassChange}
                            options={classOptions}
                            placeholder={
                                translations.labels?.selectClass ||
                                "Select Class"
                            }
                        />
                    </div>
                    <div className="col-lg-3 px-2 col-md-6 col-sm-12">
                        <CustomDropdown
                            label={
                                translations.labels?.section || "Section"
                            }
                            name="filterSection"
                            value={selectedSection}
                            onChange={handleSectionChange}
                            options={sectionOptions}
                            placeholder={
                                translations.labels?.selectSection ||
                                "Select Section"
                            }
                            disabled={!selectedClass}
                        />
                    </div>
                    <div className="col-lg-3 px-2 col-md-6 col-sm-12">
                        <CustomDropdown
                            label={
                                translations.labels?.medium || "Medium"
                            }
                            name="medium"
                            value={formData.medium}
                            onChange={handleMediumChange}
                            options={mediumOptions}
                            placeholder={
                                translations.labels?.selectMedium ||
                                "Select Medium"
                            }
                        />
                    </div>
                </div>

                {/* ── Student List heading ── */}
                <h3
                    style={{
                        fontSize: 16,
                        fontWeight: 700,
                        color: "#1e3a5f",
                        marginBottom: 12,
                    }}
                >
                    {translations.labels?.studentList || "Student List"}
                </h3>

                {/* ── Table ── */}
                <div className={styles.tableSection}>
                    <CustomMRTTable
                        columns={columns}
                        data={data}
                        loading={tableLoading}
                        pagination={pagination}
                        rowCount={rowCount}
                        placeholder={
                            translations?.labels?.searchNameCode ||
                            "Search by name..."
                        }
                        setSearchInput={setSearchInput}
                        onSearchEnter={handleSearchEnter}
                        onPaginationChange={setPagination}
                        searchInput={searchInput}
                        enableSearch={true}
                        enableFiltering={false}
                        manualPagination={true}
                    />
                </div>
            </div>
        </>
    );
};

export default ViewFeeAssign;